import {
  Radar,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  ResponsiveContainer,
} from "recharts";
import { ResultTable } from "../../types/types";
import { useEffect, useState } from "react";
import "../../styles/App.css";
//import { create } from "domain";

const Chart: React.FC<{
  jsonResult: ResultTable[];
  createChartImage: any;
 
}> = ({ jsonResult, createChartImage }) => {
  const [fontSize, setFontSize] = useState("9");

  useEffect(() => {
    const handleResize = () => {
      const screenWidth = window.innerWidth;

      // Apply conditional statements for different screen widths
      if (screenWidth <= 375) {
        setFontSize("7");
      } else if (screenWidth <= 600) {
        setFontSize("9");
      } else if (screenWidth >= 601 && screenWidth <= 900) {
        setFontSize("15");
      } else if (screenWidth >= 900 && screenWidth <= 1200) {
        setFontSize("17");
      } else if (screenWidth >= 1200 && screenWidth <= 1536) {
        setFontSize("17");
      } else {
        setFontSize("19");
      }
    };

    // Add event listener for window resize
    window.addEventListener("resize", handleResize);

    // Call handleResize initially to set dimensions based on initial screen width
    handleResize();

    // Remove event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []); // Empty dependency array ensures the effect runs only once after initial render

  useEffect(() => {
    
    createChartImage();
    console.log("This is chart continuos running useffect");
  });

  // const handleAnimationEnd = () => {
  //   createChartImage();
  //   console.log("Chart animation ended, image captured");
  // };

  // Map jsonResult data to the format expected by Recharts
  const data = jsonResult.map((result) => ({
    name: result.dimension, // Map dimension to 'name' property
    x: result.percentage, // Map percentage to 'x' property
  }));
  if (!data) {
    return <></>;
  }
  return (
    <>
      <ResponsiveContainer width="100%" aspect={3} height="90%" >
        <RadarChart outerRadius="80%" data={data}  >
          <PolarGrid />
          <PolarAngleAxis
            dataKey="name"
            tick={{
              fill: "black",
              fontSize: fontSize,
              dy: 5.5,
            }}
          />
          <PolarRadiusAxis />
          <Radar dataKey="x" stroke="green" fill="green" fillOpacity={0.5} isAnimationActive = {false} className="Radar" name = "dimensionRadar" />
        </RadarChart>
      </ResponsiveContainer>
    </>
  );
};

export default Chart;
